import * as registeredGift from '../services/registeredGift';

export default {
  namespace: 'registeredGift',
  state: {},
  effects: {
    //运营规则列表
    *queryEventPage({ payload: { values }, callback }, { call, put }) {
      //日期需要拼上时间
      let { beginDateTime, endDateTime, ...restParam } = values;
      const response = yield call(registeredGift.queryEventPage, {
        ...restParam,
        startDate: beginDateTime,
        endDate: endDateTime,
      });
      yield put({
        type: 'save',
        payload: {
          activityList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *activityDelete({ payload: { values }, callback }, { call }) {
      const response = yield call(registeredGift.activityDelete, values);
      callback(response);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
